import BaseService from '../BaseService';
import api from '../../services/api';

class TratamentosService extends BaseService {
    constructor() {
        super('/atendimentos/tratamentos/');
    }

    listar(atendimentoId, produtoUsoId = null) {
        const params = { atendimento_id: atendimentoId };

        if (produtoUsoId) {
            params.produto_uso_id = produtoUsoId;
        }

        return this.getAll(params);
    }

    compliance(atendimentoId) {
        return api.get('/atendimentos/compliance/medicamentoso/', {
            params: { atendimento_id: atendimentoId },
        });
    }
}

const tratamentosService = new TratamentosService();

export default tratamentosService;
